import { render } from "./PaymentSuccessStep.vue?vue&type=template&id=5385f977&scoped=true"
import script from "./PaymentSuccessStep.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessStep.vue?vue&type=script&lang=js"

import "./PaymentSuccessStep.vue?vue&type=style&index=0&id=5385f977&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5385f977"]])

export default __exports__